import React from 'react';

// Skeleton for KPI metric cards
export const KPIMetricSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-start justify-between mb-4">
      <div className="flex-1">
        <div className="h-4 bg-gray-200 rounded w-32 mb-3"></div>
        <div className="h-8 bg-gray-300 rounded w-24"></div>
      </div>
      <div className="w-12 h-12 bg-gray-200 rounded-lg"></div>
    </div>
    <div className="flex items-center gap-2 mt-4">
      <div className="h-3 bg-gray-200 rounded w-20"></div>
      <div className="h-3 bg-gray-200 rounded w-16"></div>
    </div>
  </div>
);

// Skeleton for conversion funnel chart
export const ConversionFunnelSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-48 mb-6"></div>
    <div className="space-y-4">
      {[1, 2, 3, 4, 5]?.map((i) => (
        <div key={i} className="space-y-2">
          <div className="flex items-center justify-between">
            <div className="h-4 bg-gray-300 rounded w-32"></div>
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </div>
          <div className="h-8 bg-gray-200 rounded" style={{ width: `${100 - i * 15}%` }}></div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for revenue analytics chart
export const RevenueChartSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-center justify-between mb-6">
      <div className="h-6 bg-gray-300 rounded w-40"></div>
      <div className="flex gap-2">
        <div className="h-8 bg-gray-200 rounded w-20"></div>
        <div className="h-8 bg-gray-200 rounded w-20"></div>
      </div>
    </div>
    <div className="h-64 bg-gray-100 rounded-lg"></div>
    <div className="flex justify-between mt-4">
      {[1, 2, 3, 4, 5, 6]?.map((i) => (
        <div key={i} className="h-3 bg-gray-200 rounded w-12"></div>
      ))}
    </div>
  </div>
);

// Skeleton for cohort retention table
export const CohortTableSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-48 mb-6"></div>
    <div className="overflow-x-auto">
      <div className="space-y-3">
        {/* Header row */}
        <div className="flex gap-3">
          {[1, 2, 3, 4, 5, 6]?.map((i) => (
            <div key={i} className="h-10 bg-gray-200 rounded w-24 flex-shrink-0"></div>
          ))}
        </div>
        {/* Data rows */}
        {[1, 2, 3, 4, 5]?.map((row) => (
          <div key={row} className="flex gap-3">
            {[1, 2, 3, 4, 5, 6]?.map((col) => (
              <div key={col} className="h-12 bg-gray-100 rounded w-24 flex-shrink-0"></div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

// Skeleton for user segmentation panel
export const SegmentationPanelSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-40 mb-6"></div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {[1, 2, 3, 4, 5, 6]?.map((i) => (
        <div key={i} className="p-4 bg-gray-50 rounded-lg space-y-3">
          <div className="flex items-center justify-between">
            <div className="h-4 bg-gray-300 rounded w-24"></div>
            <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
          </div>
          <div className="h-8 bg-gray-300 rounded w-16"></div>
          <div className="h-3 bg-gray-200 rounded w-20"></div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for behavior pattern matrix
export const BehaviorPatternSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-56 mb-6"></div>
    <div className="grid grid-cols-4 gap-2">
      {Array.from({ length: 16 })?.map((_, i) => (
        <div key={i} className="h-16 bg-gray-100 rounded"></div>
      ))}
    </div>
    <div className="flex justify-between mt-4">
      <div className="h-3 bg-gray-200 rounded w-16"></div>
      <div className="h-3 bg-gray-200 rounded w-16"></div>
    </div>
  </div>
);